import {
  useState,
  useRef,
  useEffect,
  MutableRefObject,
  Dispatch,
  SetStateAction,
} from 'react';

function useRefState<T>(initialValue: T) {
  const [state, setState] = useState(initialValue);
  const stateRef = useRef(state);
  useEffect(() => {
    stateRef.current = state;
  }, [state]);
  return [state, stateRef, setState] as [
    T,
    MutableRefObject<T>,
    Dispatch<SetStateAction<T>>,
  ];
}

export { useRefState };
export default useRefState;
